module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/sending-d2b650af61972fc9be0d79a4abdb73f0.svg";